import { render, staticRenderFns } from "./step2Base.vue?vue&type=template&id=4b1f53c2&scoped=true"
import script from "./step2Base.vue?vue&type=script&lang=js"
export * from "./step2Base.vue?vue&type=script&lang=js"
import style0 from "./step2Base.vue?vue&type=style&index=0&id=4b1f53c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f53c2",
  null
  
)

export default component.exports